import {StoreLinksComponent} from "src/app/modules/shared/components/store-links/store-links.component";
import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {Router, RouterLink} from "@angular/router";
import {User} from "src/app/modules/auth/models/User";
import {AuthService} from "src/app/modules/auth/services/auth.service";
import {ModalService} from "src/app/modules/core/services/modal.service";
import {EditProfilePreferencesComponent} from "../../modules/core/components/edit-profile-preferences/edit-profile-preferences.component";
import {UserAvatarComponent} from "../../modules/shared/components/user-avatar/user-avatar.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    StoreLinksComponent,
    RouterLink,
    EditProfilePreferencesComponent,
    UserAvatarComponent,
    TranslateModule,
  ],
})
export class ProfileComponent {
  @Input() user!: User;
  @Input() isMobile!: boolean;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly modalService: ModalService
  ) {}

  closeModals() {
    this.modalService.closeModal("profile");
  }

  logout() {
    this.modalService.closeModal();
    this.authService.logout();
    this.router.navigate(["/login"]);
  }

  onKeyUp(event: KeyboardEvent, type: string): void {
    if (event.key === "Enter" || event.key === " ") {
      if (type === "logout") {
        this.logout();
      }
    }
  }
}
